export default "__VITE_ASSET__b2898ecf__"